export enum SaleListHeaderFilterReceivedEnum {
    RECEIVED, NOT_RECEIVED, BOTH
}
